import React from 'react'

const Radiobutton = (props) => {
  const option = props.option

  return (
      <label className={`btn btn-search-small ${props.checked ? 'active' : ''}`} value={option} name={option} onClick={props.handleChange}>
        <input type="radio" id={`roadworthy-${option}`} value={option} name={option}/>
        {option}
      </label>
  )
}

export default Radiobutton
